import { hexToHsl, isWarm, isPastel, isVivid, isMoody, isNeutral, isRetro, isVintage, isNeon, isSummer, isSpring, isAutumn, isWinter, isDay, isNight, isSkin, isDark, isEarth, isCottage, hueDistance } from "./color";
import { markers, OHUHU_SET_LEGEND, ARRTX_SET_LEGEND, SFAIH_SET_LEGEND, CALIART_SETS, BIANYO_SETS, HOTU_SETS, CALM_OVER_CHAOS_SETS, HANGFAN_SETS, SANJOKI_SET_LEGEND, PRISM_SETS, ROYAL_LANGNICKEL_SETS, COPIC_SKETCH_SETS, COPIC_CLASSIC_SETS, COPIC_CIAO_SETS } from "./data";
import { getUserCollection } from "./userCollection";

export const FILTERS = [
  "Random",
  "Similar",
  "Greenish",
  "Yellowish",
  "Reddish",
  "Blueish",
  "Purplish",
  "Warm",
  "Pastel",
  "Vivid",
  "Summer",
  "Spring",
  "Autumn",
  "Winter",
  "Moody",
  "Neutral",
  "Retro",
  "Vintage",
  "Neon",
  "Day",
  "Night",
  "Dark",
  "Earth",
  "Skin",
  "Cottage",
];

export const SIMILAR_SUBFILTERS = [
  "All Hues",
  "Greenish",
  "Yellowish", 
  "Reddish",
  "Blueish",
  "Purplish"
];

function byBrand(brand, ohuhuSet = null, arrtxSet = null, sfaihSet = null, collectionBrand = null, caliartSet = null, bianyoSet = null, hotuSet = null, calmOverChaosSet = null, hangfanSet = null, sanjokiSet = null, prismSet = null, royalLangnickelSet = null, copicSketchSet = null, copicClassicSet = null, copicCiaoSet = null) {
  // Filter out blending colors (code 0) from all results
  const filterOutBlendingColors = (markerList) => markerList.filter(m => {
    if (m.code !== undefined) return m.code !== 0 && m.code !== "0";
    // For brands using code_old/code_new (Ohuhu, Sanjoki) — blender has code_old "0"
    return m.code_old !== "0" && m.code_new !== "0";
  });

  if (!brand || brand === "All") return filterOutBlendingColors(markers);

  // Handle "My Collection" - use user's personal collection
  if (brand === "My Collection") {
    const collection = getUserCollection();
    const base = collection.length > 0 ? collection : markers;
    if (collectionBrand && collectionBrand !== "All") {
      return filterOutBlendingColors(base.filter(m => m.brand === collectionBrand));
    }
    return filterOutBlendingColors(base);
  }

  // Handle special Ohuhu brand cases
  if (brand === "Ohuhu (New)" || brand === "Ohuhu (Old)" || brand === "Ohuhu") {
    let ohuhuMarkers = markers.filter(m => m.brand === "Ohuhu");

    // Filter by set if specified (not "All")
    if (ohuhuSet && ohuhuSet !== "All" && OHUHU_SET_LEGEND[ohuhuSet]) {
      ohuhuMarkers = ohuhuMarkers.filter(m => m.sets && m.sets.includes(ohuhuSet));
    }

    return filterOutBlendingColors(ohuhuMarkers);
  }

  if (brand === "Arrtx") {
    let arrtxList = markers.filter(m => m.brand === "Arrtx");
    if (arrtxSet && arrtxSet !== "All" && ARRTX_SET_LEGEND[arrtxSet]) {
      arrtxList = arrtxList.filter(m => m.sets && m.sets.includes(arrtxSet));
    }
    return filterOutBlendingColors(arrtxList);
  }

  if (brand === "SFAIH") {
    let sfaihList = markers.filter(m => m.brand === "SFAIH");
    if (sfaihSet && sfaihSet !== "All" && SFAIH_SET_LEGEND[sfaihSet]) {
      sfaihList = sfaihList.filter(m => m.sets && m.sets.includes(sfaihSet));
    }
    return filterOutBlendingColors(sfaihList);
  }

  if (brand === "Caliart") {
    let caliartList = markers.filter(m => m.brand === "Caliart");
    if (caliartSet && caliartSet !== "All" && CALIART_SETS[caliartSet]) {
      caliartList = caliartList.filter(m => m.sets && m.sets.includes(caliartSet));
    }
    return filterOutBlendingColors(caliartList);
  }

  if (brand === "Bianyo") {
    let bianyoList = markers.filter(m => m.brand === "Bianyo");
    if (bianyoSet && bianyoSet !== "All" && BIANYO_SETS[bianyoSet]) {
      bianyoList = bianyoList.filter(m => m.sets && m.sets.includes(bianyoSet));
    }
    return filterOutBlendingColors(bianyoList);
  }

  if (brand === "Hotu") {
    let hotuList = markers.filter(m => m.brand === "Hotu");
    if (hotuSet && hotuSet !== "All" && HOTU_SETS[hotuSet]) {
      hotuList = hotuList.filter(m => m.sets && m.sets.includes(hotuSet));
    }
    return filterOutBlendingColors(hotuList);
  }

  if (brand === "Calm Over Chaos") {
    let cocList = markers.filter(m => m.brand === "Calm Over Chaos");
    if (calmOverChaosSet && calmOverChaosSet !== "All" && CALM_OVER_CHAOS_SETS[calmOverChaosSet]) {
      cocList = cocList.filter(m => m.sets && m.sets.includes(calmOverChaosSet));
    }
    return filterOutBlendingColors(cocList);
  }

  if (brand === "Hangfan") {
    let hangfanList = markers.filter(m => m.brand === "Hangfan");
    if (hangfanSet && hangfanSet !== "All" && HANGFAN_SETS[hangfanSet]) {
      hangfanList = hangfanList.filter(m => m.sets && m.sets.includes(hangfanSet));
    }
    return filterOutBlendingColors(hangfanList);
  }

  if (brand === "Sanjoki") {
    let sanjokiList = markers.filter(m => m.brand === "Sanjoki");
    if (sanjokiSet && sanjokiSet !== "All" && SANJOKI_SET_LEGEND[sanjokiSet]) {
      sanjokiList = sanjokiList.filter(m => m.sets && m.sets.includes(sanjokiSet));
    }
    return filterOutBlendingColors(sanjokiList);
  }

  if (brand === "Prism") {
    let prismList = markers.filter(m => m.brand === "Prism");
    if (prismSet && prismSet !== "All" && PRISM_SETS[prismSet]) {
      prismList = prismList.filter(m => m.sets && m.sets.includes(prismSet));
    }
    return filterOutBlendingColors(prismList);
  }

  if (brand === "Royal & Langnickel") {
    let rlList = markers.filter(m => m.brand === "Royal & Langnickel");
    if (royalLangnickelSet && royalLangnickelSet !== "All" && ROYAL_LANGNICKEL_SETS[royalLangnickelSet]) {
      rlList = rlList.filter(m => m.sets && m.sets.includes(royalLangnickelSet));
    }
    return filterOutBlendingColors(rlList);
  }

  if (brand === "Copic - Sketch") {
    let list = markers.filter(m => m.brand === "Copic Sketch");
    if (copicSketchSet && copicSketchSet !== "All" && COPIC_SKETCH_SETS[copicSketchSet]) {
      list = list.filter(m => m.sets && m.sets.includes(copicSketchSet));
    }
    return filterOutBlendingColors(list);
  }

  if (brand === "Copic - Classic") {
    let list = markers.filter(m => m.brand === "Copic Classic");
    if (copicClassicSet && copicClassicSet !== "All" && COPIC_CLASSIC_SETS[copicClassicSet]) {
      list = list.filter(m => m.sets && m.sets.includes(copicClassicSet));
    }
    return filterOutBlendingColors(list);
  }

  if (brand === "Copic - Ciao") {
    let list = markers.filter(m => m.brand === "Copic Ciao");
    if (copicCiaoSet && copicCiaoSet !== "All" && COPIC_CIAO_SETS[copicCiaoSet]) {
      list = list.filter(m => m.sets && m.sets.includes(copicCiaoSet));
    }
    return filterOutBlendingColors(list);
  }

  return filterOutBlendingColors(markers.filter(m => m.brand === brand));
}

function applyFilter(dataset, filter, similarSubfilter = "All Hues") {
  if (filter === "Random") return dataset;

  if (filter === "Similar") {
    let targetHue;
    
    if (similarSubfilter === "All Hues") {
      // pick a random seed hue, then keep close hues
      const seed = dataset[Math.floor(Math.random() * dataset.length)];
      targetHue = hexToHsl(seed.hex).h;
    } else {
      // Use predefined base hue for subfilter
      targetHue = getSubfilterBaseHue(similarSubfilter);
    }
    
    // Start with a tighter range for better similarity
    let close = dataset.filter(m => hueDistance(hexToHsl(m.hex).h, targetHue) <= 20);
    
    // If not enough colors, expand the range gradually
    if (close.length < 5) {
      close = dataset.filter(m => hueDistance(hexToHsl(m.hex).h, targetHue) <= 30);
    }
    if (close.length < 3) {
      close = dataset.filter(m => hueDistance(hexToHsl(m.hex).h, targetHue) <= 45);
    }
    
    return close.length >= 3 ? close : dataset; // Ensure we have enough colors
  }

  const fns = {
    Warm: isWarm,
    Summer: isSummer,
    Spring: isSpring,
    Autumn: isAutumn,
    Winter: isWinter,
    Pastel: isPastel,
    Vivid: isVivid,
    Moody: isMoody,
    Neutral: isNeutral,
    Retro: isRetro,
    Vintage: isVintage,
    Neon: isNeon,
    Day: isDay,
    Night: isNight,
    Dark: isDark,
    Earth: isEarth,
    Skin: isSkin,
    Cottage: isCottage,
    // Color-specific filters based on hue ranges
    Greenish: (hsl) => hueDistance(hsl.h, 120) <= 45, // Green hues
    Yellowish: (hsl) => hueDistance(hsl.h, 60) <= 45,  // Yellow hues
    Reddish: (hsl) => hueDistance(hsl.h, 0) <= 45 || hueDistance(hsl.h, 360) <= 45, // Red hues (wraps around)
    Blueish: (hsl) => hueDistance(hsl.h, 240) <= 45,   // Blue hues
    Purplish: (hsl) => hueDistance(hsl.h, 300) <= 45,  // Purple hues
  };
  const fn = fns[filter];
  const filtered = dataset.filter(m => fn(hexToHsl(m.hex)));
  return filtered.length ? filtered : dataset;
}

function getSubfilterBaseHue(subfilter) {
  const hueRanges = {
    "Greenish": 120,   // Green
    "Yellowish": 60,   // Yellow
    "Reddish": 0,      // Red
    "Blueish": 240,    // Blue
    "Purplish": 300    // Purple/Magenta
  };
  return hueRanges[subfilter] || 0;
}

function uniqueByHex(arr) {
  const seen = new Set();
  return arr.filter(x => (seen.has(x.hex) ? false : (seen.add(x.hex), true)));
}

export function generatePalette({ count = 5, brand = "All", filter = "Random", similarSubfilter = "All Hues", ohuhuSet = null, arrtxSet = null, sfaihSet = null, collectionBrand = null, caliartSet = null, bianyoSet = null, hotuSet = null, calmOverChaosSet = null, hangfanSet = null, sanjokiSet = null, prismSet = null, royalLangnickelSet = null, copicSketchSet = null, copicClassicSet = null, copicCiaoSet = null, locked = {}, current = [] }) {
  // keep locked items in place
  const result = Array(count).fill(null);
  for (let i = 0; i < count; i++) {
    if (locked[i] && current[i]) result[i] = current[i];
  }

  const dataset = uniqueByHex(applyFilter(byBrand(brand, ohuhuSet, arrtxSet, sfaihSet, collectionBrand, caliartSet, bianyoSet, hotuSet, calmOverChaosSet, hangfanSet, sanjokiSet, prismSet, royalLangnickelSet, copicSketchSet, copicClassicSet, copicCiaoSet), filter, similarSubfilter));
  // remove already-locked hexes from candidates
  const lockedHexes = new Set(result.filter(Boolean).map(x => x.hex));
  const candidates = dataset.filter(x => !lockedHexes.has(x.hex));

  // fill remaining slots randomly
  for (let i = 0; i < count; i++) {
    if (!result[i]) {
      if (!candidates.length) break;
      const idx = Math.floor(Math.random() * candidates.length);
      result[i] = candidates[idx];
      candidates.splice(idx, 1);
    }
  }

  // fallback: if still nulls, backfill from dataset ignoring uniqueness
  for (let i = 0; i < count; i++) {
    if (!result[i]) result[i] = dataset[Math.floor(Math.random() * dataset.length)];
  }

  // Remove duplicates if any, even if it results in fewer colors than requested
  const seenHexes = new Set();
  const finalResult = result.filter(color => {
    if (seenHexes.has(color.hex)) {
      return false;
    } else {
      seenHexes.add(color.hex);
      return true;
    }
  });
  return finalResult;
}
